import * as React from 'react';
import { useNavigate } from "react-router-dom";

function  IconBack() {
    const navigate = useNavigate();

    const back = () => {
      navigate(-1)
    }

    return (
       
        <div className='absolute top-0 z-10 p-5'>
            <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                <button onClick={e=>back()} className="items-center">
                <svg className="w-5 h-5" fill='currentColor' aria-hidden="true" viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"></path></svg>
                </button>
            </div>
        </div>
    )
}

export default IconBack